export class CustomProductCardEnt{
    id?: string;
    image?: string;
    productName?: string;
    category?: string;
    price: number = 0;
    priceDiscount: number  = 0;
    percentage: number  = 0;
    isOnDiscount: boolean = false;
    isFavorite?: boolean;
    measurementSystemDetailId?: string;
    measurementSystemDetailValue?: string;
    colorId?: string;
    colorValue?: string;
    brand?: string;
    colors?: string;
}
